import { ConfigurationSectionResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'

export enum ConfigurationLocalAssaysSectionsTabIndex {
    BASIC = 0,
    OPERATIONS = 1,
    ASSAYSGROUPS = 2
}

export interface ConfigurationLocalAssaysSectionsModalState {
    section: Partial<ConfigurationSectionResponse>
    activeTabIndex: number
}
export const initialConfigurationLocalAssaysSectionsModalState =
    (): ConfigurationLocalAssaysSectionsModalState => ({
        section: {
            active: true
        },
        activeTabIndex: ConfigurationLocalAssaysSectionsTabIndex.BASIC
    })
